<template>
  <promotion-form />
</template>

<script>
import PromotionForm from "@/components/3pl/CRM/Promotions/PromotionForm";
export default {
  components: {
    PromotionForm,
  },
};
</script>

<style></style>
